import React, { useEffect } from "react";
import { draw } from "./draw";

export const VSFPD3Chart = ({ data, width, height, config, lRef, palette }) => {
  height = height - 4;

  useEffect(() => {
    draw(lRef.current, data, config, palette);
  }, [data, width, height, config, lRef, palette]);

  return <svg ref={lRef} width={width} height={height}></svg>;
};
